import { api } from "@/lib/api";
import type { User } from "@/types";
import { create } from "zustand";

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (token: string, user: User) => void;
  logout: () => void;
  initialize: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,

  login: (token: string, user: User) => {
    localStorage.setItem("rad_token", token);
    localStorage.setItem("rad_user", JSON.stringify(user));
    api.setToken(token);
    set({ user, isAuthenticated: true, isLoading: false });
  },

  logout: () => {
    localStorage.removeItem("rad_token");
    localStorage.removeItem("rad_user");
    api.setToken(null);
    set({ user: null, isAuthenticated: false, isLoading: false });
  },

  initialize: () => {
    const token = localStorage.getItem("rad_token");
    const userStr = localStorage.getItem("rad_user");
    if (token && userStr) {
      try {
        const user = JSON.parse(userStr) as User;
        api.setToken(token);
        set({ user, isAuthenticated: true, isLoading: false });

        // Background sync latest user role and profile from server
        api
          .get<Record<string, unknown>>("/auth/me")
          .then((data) => {
            if (data && typeof data === "object") {
              const updatedUser: User = {
                id: String(data.id || user.id),
                email: String(data.email || user.email),
                fullName: String(data.name || user.fullName),
                role: (data.role as User["role"]) || user.role,
                avatarUrl: data.avatarUrl ? String(data.avatarUrl) : user.avatarUrl,
                googleId: user.googleId || "",
              };
              localStorage.setItem("rad_user", JSON.stringify(updatedUser));
              set({ user: updatedUser });
            }
          })
          .catch((err) => {
            const msg = err instanceof Error ? err.message : String(err);
            if (msg.includes("401") || msg.includes("Unauthorized")) {
              localStorage.removeItem("rad_token");
              localStorage.removeItem("rad_user");
              api.setToken(null);
              set({ user: null, isAuthenticated: false, isLoading: false });
            }
          });
      } catch {
        set({ isLoading: false });
      }
    } else {
      set({ isLoading: false });
    }
  },
}));
